import styled from 'styled-components';
import {COLORS, FONTS, SIZES} from '../styleVars';

const Line = styled.span`
  width: auto;
  margin-right: 5%;
  margin-left: 25%;
  height: 1px;
  background-color: ${COLORS.lighterGrey};
`;

const List = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  height: ${SIZES['42']};
  padding: ${SIZES['4']} ${SIZES['16']};
`;

const Placeholder = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: ${SIZES['16']} 0;
  background-color: ${COLORS.white};
  text-align: center;
  font-family: ${FONTS.PTSans};
  font-weight: ${FONTS.regular};
  font-size: ${FONTS['12']};
  color: ${COLORS.darkerGrey};
`;

export {Line, List, Placeholder};
